import QTable from 'quasar/src/components/table/QTable.js';

export const adminUserWalletLogTableColumn = (): QTable['columns'] => [
  {
    name: 'description',
    field: 'description',
    label: 'توضیحات',
    align: 'left',
    classes: 'max-width-300'
  },
  {
    name: 'amount',
    field: 'amount',
    label: 'مقدار',
    align: 'center',
    format: value => value.toLocaleString()
  },
  {
    name: 'type',
    field: 'type',
    label: 'نوع',
    align: 'center'
  },
  {
    name: 'author',
    field: 'author',
    label: 'ایجاد کننده',
    align: 'center',
    classes: 'max-width-100'
  },
  {
    name: 'created_at',
    field: 'created_at',
    label: 'تاریخ ایجاد',
    align: 'center'
  }
]
